import React, { Component } from 'react';
import { Card, Header, Button, Image, Icon, Feed } from 'semantic-ui-react'
import * as moment from 'moment';
import { Link } from 'react-router-dom';
import * as FbUtils from '../../../Utilities/FireBaseUtils'
import { base, getOrderKey } from '../../../config/constants';
import NextStatusButton from './NextStatusButton'
import Status from '../../../config/OrderStatusConstants.js'
import ImageUploader from '../../newSite/ImageUploader'
import {
    GetTimeAgo, OrderStatus,
     ViewOrderLink,
    UpdateComment, ShowLastUpdate, ShowType, SendToConfirmOrder,
} from './DashboardParts'
import Kimoto from './Kimotos/Kimoto'
import * as Utils from '../../../Utilities/Utils'

import ViewSingleOrders from './ViewSingleOrders/ViewSingleOrders';
import UpdateStatusAlgolia from './UpdateStatus/UpdateStatusAlgolia';
import AlgoliaViewSingleOrders from './algoliaDashboard/AlgoliaViewSingleOrders';
import { updateAlgoliaUpdateOnArchivedOrder } from './algoliaDashboard/AlgoliaMiscUtils'
import CheckOrderProjectInfo from './LargeProjects/CheckOrderProjectInfo'



{/* OrderCard */ }
export default class OrderCardSmall extends Component {
    constructor(props) {
        super(props);

        //console.log(this.props);
        // console.log(" OrderCard - got user:" + JSON.stringify(this.props.user));

        this.state = {
            updateText: '',
            orderUpdates: [],
            orderUpdatesbase: [],
            viewOrderDetails: false,
            showUpdates: true,
            cranesNumber: '',
            showDesignImage: false,
            showUserImage: false
        }
    }


    componentDidMount() {
        //console.log("upx7750 ==== componentDidMount");


       // console.log("upx7751 this.props.searchNow:" + this.props.searchNow);
        if (this.props.searchNow) {
           // console.log("upx7752 orderUpdates:" + this.props.order.order_num + " " + JSON.stringify(this.props.order.orderUpdates));

            if (this.props.order.orderUpdates) {
                this.setState({
                    orderUpdatesbase: this.props.order.orderUpdates
                })
            }

        } else {
            this.syncOrderUpdates();
        }
       // console.log("aglx93: OrderCard componentDidMount props designers:" + JSON.stringify(this.props.designers, null, 3));

    }

    /**
    * FUNCTION WHEN NEW DESIGN IS UPLOADED
    */
    designUploadComplete = (uploadComplete, actualFileName, url) => {
        console.log("++++++++++:designUploadComplete");
        console.log("actualFileName:" + actualFileName);
        console.log("url:" + url);

        let updateEmail = this.props.user && this.props.user.email
            ? this.props.user.email
            : "testadmin@test.com"

        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdate = {
            designImageUrl: url,
            designUpdated: now,
            lastUpdatedBy: this.props.user.email
        }


        FbUtils.updateOrder(this.props.order.key, orderUpdate);

        this.setState({
            uploadComplete: true,
            showUploadFile: false,
            actualFileName: actualFileName,
            imageUrl: url
        });
        // this.props.history.push('/newOrder/thankYou');

        //SEND IMAGE TO DESIGN IMAGE CHATIVEW
        //(firebaseSaveUrl, imageUrl, adminEmail){
        console.log("before calling addDesignToDesignChatView addDesignToDesignChatView");
        // addDesignToDesignChatView(this.props.order.key, url, this.props.user.email);
    }


    updateCommentFormSubmit = () => {
        console.log("upx10 +++++++: updateCommentFormSubmit");
        console.log("upx12 this state updateText:" + this.state.updateText);
        console.log("upx13 this.props.order.key:" + this.props.order.key);

        if (this.state.updateText.length > 2) {

            let userEmail = this.props.user && this.props.user.email ? this.props.user.email : 'unknown';

            if (this.props.order.archived && this.props.order.objectID) {
                console.log("achx01 its alogolia and ARCHIVED this.props.order.objectID exists:" + this.props.order.objectID);

                updateAlgoliaUpdateOnArchivedOrder(this.props.order.objectID, this.state.updateText, userEmail);

                //FbUtils.insertUpdateText(this.props.order.objectID, this.state.updateText, userEmail);


                this.setState({
                    updateText: ""
                });

            } else if (this.props.order.objectID) {
                console.log("ddx372 its alogolia this.props.order.objectID exists:" + this.props.order.objectID);
                FbUtils.insertUpdateText(this.props.order.objectID, this.state.updateText, userEmail);
                this.setState({
                    updateText: ""
                });

            } else if (this.props.order.key) {
                console.log("ddx3721 its NORMAL this.props.order.key exists:" + this.props.order.key);
                FbUtils.insertUpdateText(this.props.order.key, this.state.updateText, userEmail);
                this.setState({
                    updateText: ""
                });
            }

            if (this.props.searchNow) {
                console.log("upx771001 updateCommentFormSubmit searchnow is true call refresh after time out.");

                setTimeout(this.props.setRefreshToTrue, 5000);
                setTimeout(this.props.setRefreshToFalse, 10000);

                // setTimeout(function() { this.props.setRefreshToTrue; }, 2000);
                // setTimeout(function() { this.props.setRefreshToFalse; }, 4000);
            }


            //FbUtils.insertUpdateText(this.props.order.key, this.state.updateText, this.props.user);
            // FbUtils.insertUpdateText(this.props.order.key, this.state.updateText, userEmail);
            // this.setState({
            //     updateText: ""
            // });
            //UPDATE SERVER NIGGA!


        }
    }

    /**
     * IF CLINT REJECTS DESIGN
     */
    clientRejectDesign = () => {
        console.log("+++++++: clientRejectDesign");

        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            status: Status.clnt_rejectd_dsgn,
            lastUpdated: now,
            lastUpdatedBy: this.props.user.email
            // udpatedBy: this.props.user.email
        }

        FbUtils.updateOrder(this.props.order.key, orderUpdates);
    }

    handleTextChange = (e) => {
        console.log("dx32 e.target.name:" + e.target.name);
        console.log("dx34 e.target.value:" + e.target.value);

        this.setState({
            updateText: e.target.value
        })
    }

    handleCranseNumberTextChange = (e) => {
        console.log("dx32 e.target.name:" + e.target.name);
        console.log("dx34 e.target.value:" + e.target.value);

        this.setState({
            cranesNumber: e.target.value
        })
    }

    viewOrderDetailsToggle = () => {
        console.log("+++++viewOrderDetailsToggle");
        if (this.state.viewOrderDetails) {
            this.setState({ viewOrderDetails: false })
        } else {
            this.setState({ viewOrderDetails: true })
        }
    }

    showComments = () => {
        console.log("+++++:showComments");
        console.log("showUpdates:" + this.state.showUpdates);
        if (this.state.showUpdates) {
            console.log("this.state.showUpdate is true");
            this.setState({
                showUpdates: false
            })
        } else {
            console.log("this.state.showUpdate is false");
            this.syncOrderUpdates();
            this.setState({
                showUpdates: true
            })
        }
    }

    syncOrderUpdates = () => {

        let orderKey = this.props.order.key

        if (this.props.order.key) {
            console.log("upx77 syncOrderUpdates its NORMAL this.props.order.key:" + this.props.order.key);
            orderKey = this.props.order.key

        } else if (this.props.order.objectID) {
            console.log("upx771 its ALGOLIA this.props.order.objectID exists:" + this.props.order.objectID + " orderNum:" + this.props.order.order_num);
            orderKey = this.props.order.objectID
        }

        console.log("upx773 orderKey is:" + orderKey)

        console.log("upx774 componentDidMount query String:" + 'orders/' + orderKey + '/orderUpdates');

        base.syncState('orders/' + orderKey + '/orderUpdates', {
            context: this,
            state: 'orderUpdatesbase',
            asArray: true,
            queries: {
                orderByChild: 'status',
                limitToLast: 10
            }
        });

        // base.fetch('orders/' + this.props.order.key + '/orderUpdates', {
        //     context: this,
        //     state: 'orderUpdatesbase',
        //     asArray: false,
        //     queries: {
        //         orderByChild: 'status',
        //         limitToLast: 3
        //     },
        //     then(data) {
        //         console.log("fetch data:"+data);
        //         this.setState({
        //             orderUpdatesbase: data
        //         })
        //     }
        // });

    }

    markNumbersChecked = () => {
        console.log("++++++; markNumbersChecked");

        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            numberChecked: true,
            numberCheckedOn: now
        }

        FbUtils.updateOrder(this.props.order.key, orderUpdates);
    }

    updateCranesNumber = () => {
        console.log("++++++; updateCranesNumber");
        console.log("number:" + this.state.cranesNumber);

        let tempSingleNumber = false;

        /**
         * FOR SINGLE OR DOUBLE NUMBER
         */
        if (this.state.cranesNumber.length == 1) {
            tempSingleNumber = true;
        } else {
            tempSingleNumber = false;
        }

        //create orer update orbject
        let orderUpdates = {
            jerseyNumber: this.state.cranesNumber,
            jerseyNumberSingleNumber: tempSingleNumber
        }

        //SAVE FIRST AND LAST NUMBER. 
        if (this.state.cranesNumber.length > 1) {
            console.log("length is greater than 1");

            console.log("firstDigit:" + this.state.cranesNumber.charAt(0));
            console.log("secondDigit:" + this.state.cranesNumber.charAt(1));

            let tempJerseyNumberPosition = {
                firstDigit: this.state.cranesNumber.charAt(0),
                secondDigit: this.state.cranesNumber.charAt(1)
            };

            // orderUpdates.jerseyNumberPosition = jerseyNumberPosition;

            orderUpdates = {
                jerseyNumber: this.state.cranesNumber,
                jerseyNumberSingleNumber: tempSingleNumber,
                jerseyNumberPosition: tempJerseyNumberPosition
            }

        } else {
            console.log("length is less than 1");
        }

        FbUtils.updateOrder(this.props.order.key, orderUpdates);

    }

    makeOrderLost = () => {
        console.log("++++: makeOrderLost");

        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            status: Status.lost,
            lastUpdated: now,
            lastUpdatedBy: this.props.user.email
        }

        FbUtils.updateOrder(this.props.order.key, orderUpdates);

        let daysSince = Utils.GetDaysSinceOrderPlaced(this.props.order.dateNum);
        let eventProperties = {
            status: this.props.order.status,
            daySinceOrderPlaced: daysSince
        }

    }

    sendToFindShirt = () => {
        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            status: Status.find_shirt,
            lastUpdated: now,
            lastUpdatedBy: this.props.user.email
        }

        FbUtils.updateOrder(this.props.order.key, orderUpdates);
    }

    /**
     * SEND TO CONFIRM ORDER
     */
    sendToConfirmOrder = () => {
        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            status: Status.confirm_order,
            lastUpdated: now,
            lastUpdatedBy: this.props.user.email
        }

        FbUtils.updateOrder(this.props.order.key, orderUpdates);
    }

    /**
    * SEND TO CONFIRM ORDER
    */
    markAsDelivered = () => {
        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            status: Status.delivered,
            lastUpdated: now,
            lastUpdatedBy: this.props.user.email
        }

        FbUtils.updateOrder(this.props.order.key, orderUpdates);
    }



    /**
     * SHOW THE DESIGN IMAGE
     */
    showDesignImage = () => {

        if (this.state.showDesignImage) {
            this.setState({
                showDesignImage: false
            })
        } else {
            this.setState({
                showDesignImage: true
            })
        }
    }

    /**
    * SHOW USER IMAGE
    */
    showUserImage = () => {

        if (this.state.showUserImage) {
            this.setState({
                showUserImage: false
            })
        } else {
            this.setState({
                showUserImage: true
            })
        }
    }

    bringOrderFromArchives = () => {
        console.log("bax1 +++++++++++ bringOrderFromArchivesButton");
        console.log("bax12 order number:" + this.props.order.order_num);
        console.log("bax13 order key:" + this.props.order.key);
        FbUtils.bringOrderFromArchives(this.props.order, this.props.user.email);
    }

    render() {

        const currentDesignImagePreview = this.props.order.designImageUrl && this.state.showDesignImage
            // const currentDesignImagePreview = this.props.order.designImageUrl 
            ? (<Image src={this.props.order.designImageUrl} width='250' height='250' centered bordered shape='rounded' />)
            : (<p></p>)

        const showDesignImageButton = this.props.order.itemType !== 'football' && this.props.order.itemType !== 'cranes'
            ? <Button color='orange' onClick={this.showDesignImage}>Show Design</Button>
            : ''

        const userUploadedImage = this.props.order.imageUrl && this.state.showUserImage
            ? (<Image src={this.props.order.imageUrl} size='medium' centered bordered shape='rounded' />)
            : (<p></p>)

    


        const viewSingleOrdersUi = this.props.searchNow
            ? <AlgoliaViewSingleOrders
                mainOrder={this.props.order}
                user={this.props.user}
                viewOrderDetails={this.state.viewOrderDetails}
                viewOrderDetailsToggle={this.viewOrderDetailsToggle}
                searchNow={true} />
            : <ViewSingleOrders
                mainOrder={this.props.order}
                user={this.props.user}
                viewOrderDetails={this.state.viewOrderDetails}
                viewOrderDetailsToggle={this.viewOrderDetailsToggle} />


        const bringOrderFromArchivesButton = this.props.fromArchives || this.props.order.algoliaArchived
            ? <Button color='red' onClick={this.bringOrderFromArchives}>BRING FROM ARCHIVES</Button>
            : ''

        const archivedOrder = this.props.searchNow && this.props.order.algoliaArchived
            ? <h3> *** ARCHIVED ORDER *** </h3>
            : ''

        const updateOrderUI = this.props.order.archived
            ? ''
            : < UpdateComment
                updateCommentFormSubmit={this.updateCommentFormSubmit}
                textValue={this.state.updateText}
                handleTextChange={this.handleTextChange} />

        const updateStatusAlgolia = (this.props.searchNow) && (this.props.order.archived || this.props.order.algoliaArchived)
            ? ''
            : <UpdateStatusAlgolia
                user={this.props.user}
                order={this.props.order}
                orderStatuses={this.props.orderStatuses}
                setRefreshToFalse={this.props.setRefreshToFalse}
                setRefreshToTrue={this.props.setRefreshToTrue}
                //isAdmin={this.props.isAdmin} 
                algoliaUser={this.props.algoliaUser} />

        const projectInfo = <CheckOrderProjectInfo
            user={this.props.user}
            order={this.props.order}
            orderStatuses={this.props.orderStatuses}
            algoliaUser={this.props.algoliaUser}
            searchNow={this.props.searchNow} />

        const adset = this.props.order.adset
        ? 
        <Feed>
        <Feed.Event>
          <Feed.Content>
            <Feed.Summary>
            {this.props.order.adset}
            </Feed.Summary>
          </Feed.Content>
        </Feed.Event>
        </Feed>
        :''

        const viewReplacement = this.props.order.replacementOrderNumber

        ? <div>
            <br />
            <Icon color='red' disabled name='repeat' />
            <Link to={'/dashboard/SingleOrderViewAlgolia/'+this.props.order.replacementOrderNumber} target="_blank">VIEW REPLACEMENT - {this.props.order.replacementOrderNumber}</Link>
        </div>
        : ''

    const viewOriginal = this.props.order.replacementOf_order
        ? <div>
            <br />
            <Icon color='red' disabled name='repeat' />
            <Link to={'/dashboard/SingleOrderViewAlgolia/'+this.props.order.replacementOf_order} target="_blank">VIEW ORIGINAL - {this.props.order.replacementOf_order}</Link>
        </div>
        : ''

        return (
            <Card>
                {currentDesignImagePreview}
                {showDesignImageButton}
                {bringOrderFromArchivesButton}

                <Card.Content>
                    <Card.Header>#{this.props.order.order_num}-{this.props.order.name}</Card.Header>
                    <br />
                    <Card.Header >{this.props.order.enteredBy}</Card.Header>

                    {/* ORDER TYPE */}
                    <br />
                    <ShowType order={this.props.order} />

                    {/* CREDIT SCORE */}
                    <br />
                    <Card.Header as='h1' color='purple'>CREDIT SCORE: {this.props.order.creditScore}</Card.Header>
                    
                    {adset}

                        {/* LINK TO REPLACEMENT ORDER */}
                        <br />
                    {viewReplacement}

                    {/* LINK TO REPLACEMENT ORDER */}
                    <br />
                    {viewOriginal}

                    {/* NEW VIEW FOR NEW SINGLE ORDERS */}
                    {viewSingleOrdersUi}

                    <GetTimeAgo dateNum={this.props.order.dateNum} />
                    {/* <p>{this.props.user.email}</p> */}

                    <ShowLastUpdate order={this.props.order} />

                    <OrderStatus status={this.props.order.status} />
                    <br />
  
                    {/* view order design button */}
                    <ViewOrderLink order={this.props.order} />

                </Card.Content>

                {/* SHOWS ORDER KEY*/}
                <Card.Content extra>
                    {this.props.order.key}
                    {this.props.order.objectID}
                </Card.Content>

                {/* SHOWS USER IMAGE*/}
                {userUploadedImage}
                {/* {showUserImageButton} */}


            </Card>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/OrderCardSmall.js